(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const clickableSection = target.closest('.section-content-wrapper--has-link');
    if (!(clickableSection instanceof HTMLElement)) return;

    // Let native interactive elements keep their own behavior.
    if (target.closest('a, button, input, select, textarea, label, summary, [role="button"]')) return;

    const href = clickableSection.dataset.sectionLink;
    if (!href) return;

    const openInNewTab = clickableSection.dataset.sectionLinkNewTab === 'true';
    if (openInNewTab) {
      window.open(href, '_blank', 'noopener');
      return;
    }

    window.location.href = href;
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (!(event.key === 'Enter' || event.key === ' ')) return;

    const clickableSection = target.closest('.section-content-wrapper--has-link');
    if (!(clickableSection instanceof HTMLElement)) return;

    const href = clickableSection.dataset.sectionLink;
    if (!href) return;

    event.preventDefault();
    const openInNewTab = clickableSection.dataset.sectionLinkNewTab === 'true';
    if (openInNewTab) {
      window.open(href, '_blank', 'noopener');
      return;
    }

    window.location.href = href;
  });
  } catch(e) { console.error(e); }
})();

})();
